import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { useAuth, Roles } from "../../providers/AuthContext";
import { InputRow, SelectRow, DetailRow } from "../../components/Rows";
import { getAllPaymentMethods } from "../../api/Resources";
import { FormCard, FormGrid } from "../../components/FormCard";

const CustomerForm = ({ customer, setCustomer, setHasChanges, isEdit }) => {
  const { t } = useTranslation();
  const { getAccessToken } = useAuth();

  const handleInputChange = (key, value) => {
    setCustomer((s) => ({ ...s, [key]: value }));
    setHasChanges(true);
  };

  const [paymentMethods, setPaymentMethods] = useState([]);

    const { hasRole } = useAuth();

  useEffect(() => {
    fetchPaymentMethods();
  // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional effect scope
  }, []);

  const fetchPaymentMethods = async () => {
    try {
      const apiAccessToken = await getAccessToken();
      const methods = await getAllPaymentMethods(apiAccessToken);
      setPaymentMethods(methods);
    } catch (error) {
      console.error("Error fetching payment methods:", error);
      toast.error(error?.message || t("toast.failedFetch", { entity: t("form.paymentMethod") }));
    }
  };

  return (
    <FormCard title={t("form.customerDetails")}>
      <FormGrid className="gap-y-6">
        <InputRow
          label={t("table.customerName")}
          value={customer?.name || ""}
          onChange={(v) => handleInputChange("name", v)}
          required
          readOnly
        />

        {hasRole(Roles.Admin) && (
            <InputRow
                label={t("common.organizationNumber")}
                value={customer?.organizationNumber || ""}
                onChange={(v) => handleInputChange("organizationNumber", v)}
              />
        )}

        {isEdit && (
            <>
          <SelectRow
            label={t("form.paymentMethod")}
            value={customer?.paymentMethod?.paymentMethodPublicId || ""}
            onChange={(v) => {
              setCustomer((s) => ({
                ...s,
                paymentMethod: {
                  ...(s.paymentMethod ?? {}),
                  paymentMethodPublicId: v,
                },
              }));
              setHasChanges(true);
            }}
            options={paymentMethods.map((pm) => ({
              value: pm.paymentMethodPublicId,
              label: pm.paymentMethodName,
            }))}
                      />
           
        </>
        )}
      </FormGrid>
    </FormCard>
  );
};

export default CustomerForm;
